import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourceData } from '../elements/resource/resource.types';
import { loadProjectPreview } from '../element-editor/store/editor.actions';
import {
  selectSlides,
  selectProjects,
  selectEditorFeature,
} from '../element-editor/store/selector/editor.selector';
import { IdToIRI } from '../util/iri';

type Preview =
  | {
      text?: string;
      images?: string[];
      video?: string;
    }
  | undefined;

@Component({
  selector: 'app-project-overview',
  templateUrl: './project-overview.component.html',
  styleUrls: ['./project-overview.component.scss'],
})
export class ProjectOverviewComponent implements OnInit {
  projectID = '';
  loading = false;
  errorMsg = '';

  slides$: Observable<ResourceData[]> = this.store.select(selectSlides);
  projects$ = this.store.select(selectProjects);
  projectId$ = this.route.paramMap.pipe(map(pm => pm.get('projectID') || ''));
  projectPreviewIsLoading$ = this.store
    .select(selectEditorFeature)
    .pipe(map(s => !!s.projectPreviewIsLoading));
  projectLabel$: Observable<string | undefined> = combineLatest([
    this.projects$,
    this.projectId$,
  ]).pipe(
    map(
      ([projects, pid]) =>
        (projects?.[IdToIRI(pid)]?.literals as { label?: string } | undefined)
          ?.label,
    ),
  );

  constructor(
    private route: ActivatedRoute,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const pid = params.get('projectID') || '';
      this.projectID = pid;
      if (pid) this.store.dispatch(loadProjectPreview({ projectID: pid }));
    });
  }

  previewOf(file: ResourceData): Preview {
    const literals = (file?.literals ?? {}) as {
      descriptor?: { preview?: Preview };
    };
    return (literals.descriptor?.preview as Preview) || undefined;
  }

  s3Url(id?: string | null): string {
    return id
      ? `https://s3.eu-central-1.amazonaws.com/nowords-vlog.illustrations/${id}`
      : '';
  }
}
